module.exports = __webpack_public_path__ + "img/chongdianapp2880.05c51337.png";